import { render } from "./ProfileSlotDetails.vue?vue&type=template&id=bb6a997c&scoped=true"
import script from "./ProfileSlotDetails.vue?vue&type=script&lang=js"
export * from "./ProfileSlotDetails.vue?vue&type=script&lang=js"

import "./ProfileSlotDetails.vue?vue&type=style&index=0&id=bb6a997c&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb6a997c"]])

export default __exports__